// extracted by mini-css-extract-plugin
export default {"header":"Articles_header__tQWcu","articles":"Articles_articles__+qq74","article":"Articles_article__Vk+rZ","description":"Articles_description__CaRf9","info":"Articles_info__WA8-W"};